
const AddLicenseRightsHeader = ({ Column_name, name, disabled, func }) => {
  return (
    <th className="table-header">
      <p>{Column_name}</p>
      {name === "Page_Access" ? (
        <input type="checkbox" name={name} onChange={func} />
      ) : (
        <input type="checkbox" name={name} disabled={disabled} onChange={func} />
      )}
    </th>
  );
};

export default AddLicenseRightsHeader;
